<script>
import ScoreResult from './ScoreResult.svelte'
</script>

<style>
h1 {
    text-align: center;
}
.triage {
    border-top: 0.2rem solid rgba(0,175,170,1);
    font-family: bebas-neue-by-fontfabric,sans-serif;
	font-weight: 700;
	font-style: normal;
    padding: 2rem 1rem 2rem 1rem;
    width: 100%;
}

.triage img {
    height: 50px;
    width: 50px;
    opacity: 0.5;
    padding: 15px;
}

.triage a {
    font-size: 1.25rem;
    color: black;
}

.triageGreen {
    color: rgba(0,175,170,0.5);
}

</style>


<div id="triage" class="triage">
    <h1>Triage Assistance</h1>
    <h1 class="triageGreen">Under Construction</h1>
    <ul>
        <li>Additional Severity Score Examples</li>
        <li>Blood Pressure</li>
        <li>Urgent Care and Emergency Room Escalation </li>
    </ul>  
</div>
